// extracted by mini-css-extract-plugin
module.exports = {"product":"single-product_component_product__tKHwG","avatar":"single-product_component_avatar__K0Rsy","name":"single-product_component_name__Izsk5"};